import React, { useState } from "react";
import DropDown from "../../DropDown/DropDown";
import { Form, Row, Col } from "react-bootstrap";
import CompanyAPIs from "../../../MasonyFixingsAPIs/CompanyAPIs/CompanyAPIs";
import { useNavigate } from "react-router-dom";
import ApiResponseHandler from "../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../Contexts/ToastContext";

export default function CreateCompany(){

    const {addToast} = useToast();
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);
    const [name, setName] = useState('');
    const [website, setWebsite] = useState('');
    const [email, setEmail] = useState('');
    // const [companyTypeID, setComanyTypeID] = useState(1);

    const [phone, setPhone] = useState('');
    const [line1, setLine1] = useState('');
    const [line2, setLine2] = useState('');
    const [city, setCity] = useState('');
    const [countyID, setCountyID] = useState(0);
    const [countryID, setCountryID] = useState(0);


    const AddNewCompany = (e) => {

        e.preventDefault();
        e.stopPropagation();
        
        setSending(true);
        const addressJSON = {
            line1: line1,
            line2: line2,
            city: city,
            county_id: countyID,
            country_id: countryID,
        }

        const headOffice = {
            phone: phone,
            address: addressJSON
        }

        const postJSON = {
            name: name,
            website: website,
            email: email,
            company_type_id: 1,
            head_office: headOffice
        }

        CompanyAPIs.PostCompany(postJSON)
        .then((response) => {
            if(response.status === 200){
                // handleAddNew();
                setSending(false);
                addToast({ message: "Company created successfully!", variant: "success", autoHide: true });
                navigate('/companies/' + response.data.id)
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
    }


    return(
        
        // <form onSubmit={AddNewCompany}>
        //     <Row>
        //         <Col>
        //             <button type="button" onClick={() => handleCancel()}>Cancel</button>
        //         </Col>
        //         <Col align='end'>
        //             <button disabled={sending} type="submit">{sending?'Creating...':'Create'}</button>
        //         </Col>
        //     </Row>
            
        //     <h4>
        //     <Form.Group as={Row}>
        //         <Form.Label column sm={3}>Name</Form.Label>
        //         <Col>
        //             <Form.Control size='sm'disabled={sending} onChange={(e) => setName(e.target.value)} required value={name} />
        //         </Col>
        //     </Form.Group>
        //     </h4>
        //     <div>
        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>Website</Form.Label>
        //             <Col>
        //                 <Form.Control size='sm'disabled={sending} value={website} onChange={(e) => setWebsite(e.target.value)} />
        //             </Col>
        //         </Form.Group>
        //     </div>
        //     <div>
        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>Email: </Form.Label>
        //             <Col>
        //                 <Form.Control size='sm' disabled={sending} type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        //             </Col>
        //         </Form.Group>
        //     </div>
            

        //     <h4>Head Office:</h4>

        //     <Form.Group as={Row}>
        //         <Form.Label column sm={3}>Phone</Form.Label>
        //         <Col>
        //             <Form.Control size='sm' disabled={sending} value={phone} onChange={(e) => setPhone(e.target.value)} />
        //         </Col>
        //     </Form.Group>
        
            
            
        //     <h5>Address</h5>
        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>Line 1</Form.Label>
        //             <Col>
        //                 <Form.Control size='sm' required disabled={sending} value={line1} onChange={(e) => setLine1(e.target.value)} />
        //             </Col>
        //         </Form.Group>

        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>Line 2</Form.Label>
        //             <Col>
        //                 <Form.Control disabled={sending} value={line2} onChange={(e) => setLine2(e.target.value)} />
        //             </Col>
        //         </Form.Group>

        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>City</Form.Label>
        //             <Col>
        //                 <Form.Control size='sm' disabled={sending} value={city} onChange={(e) => setCity(e.target.value)} />
        //             </Col>
        //         </Form.Group>

        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>County</Form.Label>
        //             <Col>
        //                 <DropDown.County size='sm' disabled={sending} required value={countyID} onChange={(e) => setCountyID(e.target.value)} />
        //             </Col>
        //         </Form.Group>

        //         <Form.Group as={Row}>
        //             <Form.Label column sm={3}>Country</Form.Label>
        //             <Col>
        //                 <DropDown.Country size='sm' disabled={sending} required value={countryID} onChange={(e) => setCountryID(e.target.value)} />
        //             </Col>
        //         </Form.Group>
    

            
        // </form>

        <div className='tab-panel active'>
            <Form onSubmit={AddNewCompany}>
                <div className="project-section">

                    <div className="project-section-header">
                    <h5 className="section-title">Create New Company</h5>
                    <div className="project-header-actions">
                        <button disabled={sending} type='button' onClick={() => navigate('/companies')} className="cancel-btn">Back</button>
                        <button disabled={sending} type='submit' className="edit-btn">Save</button>
                    </div>
                    </div>
                

                    <div className="m-2">

                        <div className="project-section-body-item">
                            <span className="label">Name</span>
                        </div>
                        <div>
                            <Form.Control size='sm' disabled={sending} className='project-title-input editable-field' onChange={(e) => setName(e.target.value)} required value={name} />
                        </div>

                        <div className="project-section-body mt-2 mb-2">


                            <div className="project-section-body-item">
                                <span className="label">Phone</span>
                                <Form.Control size='sm' disabled={sending} className='editable-field' value={phone} onChange={(e) => setPhone(e.target.value)}/>
                            </div>


                            <div className="project-section-body-item">
                                <span className="label">Email</span>
                                <Form.Control size='sm' type='email' disabled={sending} className='editable-field' value={email} onChange={(e) => setEmail(e.target.value)} />
                            </div>

                            <div className="project-section-body-item">
                                <span className="label">Website</span>
                                <Form.Control size='sm' disabled={sending} className='editable-field' value={website} onChange={(e) => setWebsite(e.target.value)}/>
                            </div>
                        </div>





                        <h5 className="section-title mt-2 mb-1">Company Address</h5>
                        
                            <div className="project-section-body">
            
                            
            
                            <div className="project-section-body-item">
                                <span className="label">Line 1</span>
                                <Form.Control size='sm' disabled={sending} className="editable-field" required value={line1} onChange={(e) => setLine1(e.target.value)} />
                            </div>
            
                            <div className="project-section-body-item">
                                <span className="label">Line 2</span>
                                <Form.Control size='sm' disabled={sending} className="editable-field" value={line2} onChange={(e) => setLine2(e.target.value)} />
                            </div>
            
                            <div className="project-section-body-item">
                                <span className="label">City</span>
                                <Form.Control size='sm' disabled={sending} className="editable-field" value={city} onChange={(e) => setCity(e.target.value)} />
                            </div>
            
                            <div className="project-section-body-item">
                                <span className="label">County</span>
                                <DropDown.County size='sm' disabled={sending} className="editable-field" required value={countyID} onChange={(e) => setCountyID(e.target.value)} />
                            </div>
            
                            <div className="project-section-body-item">
                                <span className="label">Country</span>
                                <DropDown.Country size='sm' required value={countryID} onChange={(e) => setCountryID(e.target.value)} />
                            </div>
                        </div>
                        
                    </div>
                </div>
            </Form>
        </div>
    )

}